export default __webpack_public_path__ + "static/media/icon-frame-crown.8881eb95.svg";